import { Provider } from '@angular/core';
import { environment } from 'src/environments/environment';
import { API_BASE_URL } from 'src/shared/api';

export const baseUrlProvider: Provider = {
	provide: API_BASE_URL,
	useFactory: () => {
		return `${environment.API_BASE_URL}`;
	},
};
